<div class="provider-item" [class]="status()" [class.compact]="compact()">
  <div class="item-wrap" layout layout-space-between layout-align-items-center>
    <div class="item-content" layout layout-align-items-center>
      <div class="logo-wrap">
        <ng-container *ngTemplateOutlet="avatar" />
      </div>

      <div class="text-wrap" layout layout-vertical>
        @if (header && !compact()) {
          <rt-heading>{{ header }}</rt-heading>
        } @else {
          <ng-template [ngTemplateOutlet]="compact() && header ? compactTemplate : headerTpl()" />
        }
        @if (description) {
          <span class="description">{{ description }}</span>
        } @else {
          <ng-template [ngTemplateOutlet]="descriptionTpl()" />
        }
      </div>
    </div>
    <div class="item-actions" layout>
      <ng-content />
    </div>
  </div>
  <div class="item-footer">
    @if (footerTpl()) {
      <ng-template [ngTemplateOutlet]="footerTpl()" />
    }
  </div>
</div>

<ng-template #avatar>
  <rt-avatar
    [type]="initials() ? 'initials' : 'icon'"
    [size]="iconSize()"
    [shape]="'square'"
    [iconName]="icon()"
    [isColorized]="!!initials()"
    [initials]="initials()"
    [iconColor]="iconToken()"
  />
</ng-template>
<ng-template #compactTemplate>
  <div layout layout-align-items-center>
    <rt-heading margin-right-small-x>{{ header }}</rt-heading>
    @if (status() === 'connected') {
      <rt-badge
        color="draft"
        iconName="check"
        [text]="'app.email_provider_common.connected' | translate"
      />
    }
  </div>
</ng-template>
